export const validatePassword = (value: string): boolean => {
	const minLength = 8;
	return value.length >= minLength;
};
